import { isAxiosError } from 'axios';

const NON_RETRYABLE_STATUSES = [401, 403, 404];

// Auth and permission failures are deterministic (tokens are injected fresh on
// every request), so they are never retried. Other failures get one retry:
// that heals transient blips, while persistent failures surface fast — and the
// global error dialog offers a manual retry.
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  if (status !== undefined && NON_RETRYABLE_STATUSES.includes(status)) {
    return false;
  }
  return failureCount < 1;
}
